/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import * as emotion from "emotion";
import {AlertsModule, OnAlertsUpdated} from "@modules/AlertsModule";
import {COLORS} from "@res/colors";
import {Badge} from "../../widget/Badge";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {OnTimeFilterChanged} from "@modules/UserPreferencesModule";
import {DB_Patient} from "@app/app-shared/patient";

export const AlertDot = emotion.css(
    {
        height: 13,
        width: 13,
        backgroundColor: COLORS.secondary_red,
        borderRadius: '100%'
    }
)

type Props = {
    top?: number
    right?: number
    patient: DB_Patient
    children: React.ReactNode
}

export class AlertBadge
    extends BaseComponent<Props>
    implements OnAlertsUpdated, OnTimeFilterChanged {

    constructor(props: Props) {
        super(props);
    }

    __onAlertsUpdated() {
        this.forceUpdate();
    }

    __onTimeFilterChanged() {
        this.forceUpdate();
    }

    render() {
        const patient = this.props.patient;
        const show = AlertsModule.existsUnresolvedPatientAlert(patient?._id);

        return <Badge
            show={show}
            top={this.props.top}
            right={this.props.right}
            badge={<div className={AlertDot}/>}
        >
            {this.props.children}
        </Badge>
    }

}
